module.exports = __webpack_public_path__ + "static/media/commentExclamationBlue.28cfb4c2.svg";